module.exports = __webpack_public_path__ + "static/sport/title.f146156.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/title.png
// module id = FM5v
// module chunks = 0